module.exports = __webpack_public_path__ + "img/whatsapp.5c3f8478.png";